/* @flow */
/* eslint-env es6,browser */

// $FlowFixMe
import template from 'underscore/modules/template.js'; // eslint-disable-line import/extensions
import _multiidpbase from './multiidpbase';
import { IDP_VZM, USER_ID_VERIZON } from './idpconstants';
import getCVars from '../utils/gputils';
import { isEmptyObject, isNonEmptyObject } from '../utils/coreutils';
import { logDebug, logError } from '../utils/logger';
import { getCCPA } from '../utils/ccpautils';
import { fetchJSON, isFetchSupported } from '../utils/fetch';
import { getPageUrl, isJSONSupported } from '../utils/browserutil';
import {
  getFromStore,
  saveToStore,
  getStoredValueTS
} from '../utils/storageutils';

// To be consistent with staticAS, let's use same interpolation.
// We are going to use GAM style templating for interpolation. Let's use %%VAR%% here
const templateSettings = {
  interpolate: /%%(.*?)%%/g
};

const STORAGE_KEY = 'connectId';
const OPTOUT_STORAGE_KEY = 'connectIdOptOut';

// key map
const VERIZON_IDP_KEYS = {
  [USER_ID_VERIZON]: 'connectId'
};

// pixelId is passed & stored in pid

/**
 * @description Implement functionality to get ID from Verizon Media
 * @module vzmidp
 */
// pixelId is passed & stored in pid

/**
 * @description Implement functionality to get ID from Verizon Media
 * @module vzmidp
 */
class _vzmidp extends _multiidpbase {
  constructor(name: string) {
    super(name);
    this._optoutKeys = [OPTOUT_STORAGE_KEY];
  }

  _isSupported(): boolean {
    return super._isSupported() && isFetchSupported() && isJSONSupported();
  }

  _shouldRefresh(): boolean {
    return (
      super._shouldRefresh() ||
      getStoredValueTS(
        STORAGE_KEY,
        this._refreshInterval * 60,
        this._storage
      ) === 0
    );
  }

  _loadFromCache(): boolean {
    // load values from the cache
    if (Object.keys(this._cachedObj).length !== 0) {
      return true;
    }
    const o = JSON.parse(getFromStore(STORAGE_KEY, this._storage) || '{}');
    if (isEmptyObject(o)) {
      return false;
    }
    // check email hash and use only if it matches
    const { he: storedHe = '' } = o;
    const { _uh6: he = '' } = getCVars();
    if (he !== storedHe) {
      logDebug(
        `${this._name} ignoring stored value as email hash is not matching!`
      );
      return false;
    }
    // now load from cache
    // parse and store for easy retrieval
    Object.entries(VERIZON_IDP_KEYS).forEach(([id, remoteKey]) => {
      const cVal = o[remoteKey] || '';
      if (cVal) {
        this._cachedObj[id] = cVal;
      }
    });
    // store the last timestamp
    if (this._refreshInterval > 0) {
      this._idUpdateTime =
        getStoredValueTS(
          STORAGE_KEY,
          this._refreshInterval * 60,
          this._storage
        ) || this._idUpdateTime;
    }
    return Object.keys(this._cachedObj).length > 0;
  }

  _refreshID() {
    const pixelId = this._pid;
    if (pixelId.length === 0 || this._url.length === 0) {
      return;
    }
    // eslint-disable-next-line camelcase
    const us_privacy = getCCPA();
    const { _uh6: he = '' } = getCVars();
    const reqUrl = template(this._url, templateSettings)({ pixelId });
    const url = getPageUrl();
    const req = {
      credentials: 'include',
      mode: 'cors'
    };
    const opt = {
      data: {
        v: 1,
        pixelId,
        he,
        us_privacy, // eslint-disable-line camelcase
        url
      },
      logPrefix: IDP_VZM,
      timeout: 2000
    };

    fetchJSON(reqUrl, opt, req)
      .then(json => {
        if (!isNonEmptyObject(json)) {
          return true;
        }
        // store the email hash if available.
        const cacheResponse = {
          ...json,
          he
        };
        saveToStore(
          {
            name: STORAGE_KEY,
            value: JSON.stringify(cacheResponse),
            expires: this._nExpireDays * 24 * 60 * 60
          },
          this._refreshInterval > 0,
          this._storage
        );
        // clear and reload the value
        this._cachedObj = {};
        this._loadFromCache();
        return true;
      })
      .catch(error => {
        logError(`IDP_VZM Failed to get ID : ${error || ''}`);
      });
  }
}

const vzmidp: _vzmidp = new _vzmidp(IDP_VZM);
export default vzmidp;
